import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography, Card, CardContent, Switch } from "@mui/material";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TableCompo from "../MainScreens/Table/TableCompo";
import { CustomerType } from "../../configs/constants";
import { getBirthdayCustomersRequest } from "../../redux/Dashboard/dashboardSlice";
import { getReferralListRequest } from "../../redux/Referral/referralSlice";
import { useLocation } from "react-router-dom";

const BirthdayCustomerList = () => {
  const dispatch = useDispatch();
  const { birthdayData = { customers: [], totalCount: 0 }, birthdayLoading } =
    useSelector((state) => state.dashboard);
  const referralState = useSelector((state) => state.referral);

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");

  const location = useLocation();
  const initialRange = location.state?.range || 7;

  useEffect(() => {
    const referralcode = sessionStorage.getItem("selectedReferralCode");

    if (referralcode) {
      dispatch(
        getReferralListRequest({
          referralcode,
          page: page + 1,
          limit,
          search,
        })
      );
    } else if (initialRange) {
      dispatch(
        getBirthdayCustomersRequest({
          range: initialRange,
          page: page + 1,
          limit,
          search,
        })
      );
    }
  }, [dispatch, page, limit, search, initialRange]);

  const handleTableChange = (action, tableState) => {
    switch (action) {
      case "changeRowsPerPage":
        setPage(0);
        setLimit(tableState["rowsPerPage"]);
        break;
      case "search":
        setSearch(tableState.searchText || "");
        setPage(0);
        break;
      case "changePage":
        setPage(tableState["page"]);
        setLimit(tableState["rowsPerPage"]);

        break;
    }
  };

  const columns = [
    {
      field: "createdAt",
      headerName: "Registration Date",
      minWidth: 220,
      render: (val, row) => {
        if (!row?.createdAt) return "N/A";
        const date = new Date(row.createdAt);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";
        const hour12 = hours % 12 || 12;
        return `${day}-${month}-${year} ${hour12}:${minutes} ${ampm}`;
      },
    },
    {
      field: "fullName",
      headerName: "Name",
      render: (val, row) =>
        `${row.firstName || ""} ${row.lastName || ""}`.trim(),
    },
    {
      field: "phone",
      headerName: "Phone",
      minWidth: 150,
    },
    {
      field: "State",
      headerName: "State",
      render: (val, row) =>
        row.address && row.address.length > 0
          ? row.address[0].state || "N.A"
          : "N.A",
    },
    {
      field: "City",
      headerName: "City",
      render: (val, row) =>
        row.address && row.address.length > 0
          ? row.address[0].city || "N.A"
          : "N.A",
    },
    { field: "gender", headerName: "Gender" },
    {
      field: "age",
      headerName: "Age",
      minWidth: 50,
      render: (val, row) => {
        if (!row.dateOfBirth) return "N/A";
        const dob = new Date(row.dateOfBirth);
        const today = new Date();
        let age = today.getFullYear() - dob.getFullYear();
        const monthDiff = today.getMonth() - dob.getMonth();
        const dayDiff = today.getDate() - dob.getDate();
        if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
          age--;
        }
        return age;
      },
    },
    {
      field: "birthdayRemainingDays",
      headerName: "Birthday Remaining Days",
      minWidth: 100,
      render: (val, row) => {
        if (!row.dateOfBirth) return "N/A";
        const today = new Date();
        const dob = new Date(row.dateOfBirth);
        let nextBirthday = new Date(
          today.getFullYear(),
          dob.getMonth(),
          dob.getDate()
        );
        if (nextBirthday < today) {
          nextBirthday.setFullYear(today.getFullYear() + 1);
        }
        const diffTime = nextBirthday - today;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return `${diffDays} days`;
      },
    },
    {
      field: "currentLoginAt",
      headerName: "Last Login",
      minWidth: 200,
      render: (val, row) => {
        if (!row.logindetails) return "N/A";

        const date = new Date(row.logindetails.currentLoginAt);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";
        const hour12 = hours % 12 || 12;

        return `${day}-${month}-${year} ${hour12}:${minutes} ${ampm}`;
      },
    },

    {
      field: "enabled",
      headerName: "STATUS",
      render: (val, row) => (
        <span
          style={{
            color: row.enabled ? "green" : "red",
            fontWeight: "bold",
            textTransform: "uppercase",
            cursor: "pointer",
          }}
        >
          {row.enabled ? "ENABLED" : "DISABLED"}
        </span>
      ),
    },
    {
      field: "dateOfBirth",
      headerName: "Date Of Birth",
      render: (val, row) => {
        if (!row.dateOfBirth) return "N/A";
        const date = new Date(row.dateOfBirth);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      },
    },
    {
      field: "kycstatus",
      headerName: "KYC Status",
      render: (val, row) => {
        const status = row.kycstatus || "N/A";
        const colorMap = {
          APPROVED: "green",
          PENDING: "orange",
          REJECTED: "red",
        };
        return (
          <span
            style={{
              backgroundColor: colorMap[status] || "gray",
              color: "#fff",
              padding: "4px 8px",
              borderRadius: "6px",
              fontWeight: "bold",
            }}
          >
            {status}
          </span>
        );
      },
    },
    {
      field: "customer_type",
      headerName: "Customer Type",
      render: (_, row) => {
        return (
          <Box display="flex" alignItems="center" gap={1}>
            <Switch
              key={row._id}
              checked={row.customer_type == CustomerType.vip ? true : false}
              color="primary"
            />
            <Typography variant="body2">{row.customer_type}</Typography>
          </Box>
        );
      },
    },
    {
      field: "referralcode",
      headerName: "Referral Code",
      render: (val, row) =>
        row?.referralcode ? (
          <button
            style={{
              background: "linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)",
              fontFamily: "inherit",
              color: "#fff",
              border: "none",
              padding: "5px 12px",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            {row.referralcode}
          </button>
        ) : (
          "N.A"
        ),
    },
    {
      field: "joining_code",
      headerName: "Joining Code",
      render: (_, row) => row?.joining_code ?? 0,
    },
  ];
  const referralcode = sessionStorage.getItem("selectedReferralCode");

  const tableData = referralcode
    ? referralState.data || []
    : birthdayData?.customers || [];

  const totalCount = referralcode
    ? referralState.total || 0
    : birthdayData?.totalCount || 0;

  const loading = referralcode ? referralState.loading : birthdayLoading;
  return (
    <Box sx={{ width: "98%" }}>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          mt: { xs: 10, md: 10 },
          mb: { xs: 5, md: 5 },
          background: "#fff",
          borderRadius: "3px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <Typography fontWeight={700} fontSize={24} p={2} fontFamily={"Aeonik"}>
          Customer List
        </Typography>
        <CardContent sx={{ width: "100%" }}>
          <TableCompo
            columns={columns}
            data={tableData || []}
            loading={loading}
            totalCount={totalCount || 0}
            page={page}
            limit={limit}
            pageSize={limit}
            onTableChange={handleTableChange}
          />
        </CardContent>
      </Box>
    </Box>
  );
};

export default BirthdayCustomerList;
